import { useContext } from 'react';
import { CreateCommunicationContext } from '@/contexts';

export const useCreateCommunicationContext = () => {
  const context = useContext(CreateCommunicationContext);

  if (!context) {
    throw new Error(
      'useCreateCommunicationContext must be used within CreateCommunicationsContextProvider',
    );
  }

  return context;
};

